import $ from 'jquery';
import 'slick-carousel';

const defaults = {
  speed: 500,
  fade: true,
  autoplay: true,
  autoplaySpeed: 4000,
  dots: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 690,
      settings: {
        arrows: false,
      },
    },
  ],
};

export default class Gallery {
  constructor(element, options) {
    this.element = element;
    this.$element = $(element);
    this.settings = Object.assign({}, defaults, options);
    this.$gallery = this.build();
    this.ready();
  }

  build() {
    return this.$element.slick(this.settings);
  }

  ready() {
    this.$element.addClass('ready');
  }
}
